import { AccountCurrencies } from '../adaccounts/types'
import { Currency } from '../user/types'

export enum FinancialTermsAction {
  SLICE_NAME = 'financialTerms',
  FETCH_FINANCIAL_TERMS_FB = 'financialTerms/fetchFinancialTermsFB',
}

export interface ICashbackCondition {
  id: number
  start_range: number
  end_range: number
  value: number
}

interface IConditions {
  conditions: ICashbackCondition[]
}

interface IFinancialTermsFB {
  cashback_partner: IConditions | null
  cashback_standard: IConditions | null
  commission_partner: number
  commission_standard: number
  loading: boolean
  min_first_refill_partner: number
}

export interface ITelegramSubjectInfo {
  cashback: IConditions | null
  commission_eur: number
  commission_ton: number
  min_refill_amount_eur: number
  min_refill_amount_ton: number
  min_refill_amount_with_commission_eur: number
  min_refill_amount_with_commission_ton: number
  tax_rate: number
}

export interface ITikTokConditions {
  commission: number
  min_refill_amount: number
}

export interface IFinancialTermsState {
  financialTermsFB: IFinancialTermsFB
}

interface ICurrencyMinPayment {
  first: number
  next: number
}

export type GlobalCurrency = Currency | AccountCurrencies.AZN

export interface IRefillConditions {
  min_payment: Record<GlobalCurrency, ICurrencyMinPayment>
  exchange_rate_percent: number
  acquiring_percent: number
  acquiring_commission_percent: number
}

export interface ITelegramSubject {
  value: string
  name: string
}

export interface ITelegramCountries {
  value: string
  display_name: string
}
